/**
 * Handles Event Type related functions.
**/
function eventTypeService(configService) {

  /**
   * Gets the Event type.
   * @param {Array} events
   * @param {Array} outdoorEvents
   * @param {Array} indoorEvents
   * @returns {String} eventType
   */
  function getEventType(events, outdoorEvents, indoorEvents) {

    for (let i = 0; i < events.length; i++) {

      const eventCode = events[i].eventCode;
      // checks for eventCode availability in outdoor type events category.
      if (outdoorEvents.indexOf(eventCode) !== -1) {

        return 'outdoor';

      }
      // checks for eventCode availability in indoor type events category.
      if (indoorEvents.indexOf(eventCode) !== -1) {

        return 'indoor';

      }

    }
    return '';

  }

  /**
   * Gets the event type text.
   * @param {Array} events
   * @returns {String} eventType corresponding text.
   */
  function getEventTypeText(events) {

    const eventType = getEventType(
      events,
      configService.outdoor_events,
      configService.indoor_events
    );
    if (!eventType) {

      return configService.messages.gps.not_recognized_event_type;

    }
    return configService.messages.gps[`${eventType}_text`];

  }

  return {
    getEventType,
    getEventTypeText
  };

}

export default eventTypeService;


// WEBPACK FOOTER //
// ./src/services/eventType.service.js